import * as am5 from '@amcharts/amcharts5';
import * as am5map from '@amcharts/amcharts5/map';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import { ElementRef } from '@angular/core';
import { RegionData, RegionGeoJson, RegionValues, Regions } from '../../models';
import { formatCurrency } from '@angular/common';
import am5themes_Responsive from '@amcharts/amcharts5/themes/Responsive';

const cities: Record<Regions, (rate: number) => GeoJSON.GeoJSON> = {
    west: (rate: number) => ({
        type: 'FeatureCollection',
        features: [
            {
                id: '1',
                type: 'Feature',
                properties: {
                    name: 'West Label',
                    rate,
                },
                geometry: {
                    type: 'Point',
                    coordinates: [-111.891, 40.7608],
                },
            },
        ],
    }),
    southwest: (rate: number) => ({
        type: 'FeatureCollection',
        features: [
            {
                id: '1',
                type: 'Feature',
                properties: {
                    name: 'New York City',
                    rate,
                },
                geometry: {
                    type: 'Point',

                    coordinates: [-97.78768199919438, 32.81335335640486],
                },
            },
        ],
    }),
    southeast: (rate: number) => ({
        type: 'FeatureCollection',
        features: [
            {
                id: '1',
                type: 'Feature',
                properties: {
                    name: 'New York City',
                    rate,
                },
                geometry: {
                    type: 'Point',
                    coordinates: [-84.39975769427478, 33.9630348319188],
                },
            },
        ],
    }),
    northeast: (rate: number) => ({
        type: 'FeatureCollection',
        features: [
            {
                id: '1',
                type: 'Feature',
                properties: {
                    name: 'Northeast Label',
                    rate,
                },
                geometry: {
                    type: 'Point',
                    coordinates: [-73.7562, 42.6526],
                },
            },
        ],
    }),
    midwest: (rate: number) => ({
        type: 'FeatureCollection',
        features: [
            {
                id: '1',
                type: 'Feature',
                properties: {
                    name: 'Midwest Label',
                    rate,
                },
                geometry: {
                    type: 'Point',
                    coordinates: [-93.9345, 43.2565],
                },
            },
        ],
    }),
};

export function createGraph(
    container: ElementRef<any>,
    geoJsonMap: RegionGeoJson,
    data: RegionData,
    regionData: RegionValues,
) {
    /* Chart code */
    // Create root
    const root = am5.Root.new(container.nativeElement);
    const responsive = am5themes_Responsive.new(root);

    // Set themes
    root.setThemes([am5themes_Animated.new(root),responsive]);

    const tooltip = am5.Tooltip.new(root, {
        getFillFromSprite: false,
        getStrokeFromSprite: true,
    });

    tooltip.get('background').setAll({
        fill: am5.color('#000000'),
        fillOpacity: 0.8,
    });

    // Create chart
    const chart = root.container.children.push(
        am5map.MapChart.new(root, {
            panX: 'none',
            panY: 'none',
            wheelX: 'none',
            wheelY: 'none',
            projection: am5map.geoAlbersUsa(),
            layout: root.horizontalLayout,
        }),
    );



    Object.entries(geoJsonMap).forEach(
        ([key, geoJSON]: [string, any], index) => {
            const polygonSeries2 = chart.series.push(
                am5map.MapPolygonSeries.new(root, {
                    geoJSON,
                    valueField: 'value',
                }),
            );

            const polygonSeries = chart.series.push(
                am5map.MapPolygonSeries.new(root, {
                    geoJSON,
                    valueField: 'value',
                }),
            );

            polygonSeries.mapPolygons.template.setAll({
                stroke: am5.color('#192129'),
                fill: am5.color('#192129'),

                templateField: 'polygonSettings',
            });

            polygonSeries2.mapPolygons.template.setAll({
                templateField: 'polygonSettings2',
            } as Partial<am5map.IMapPolygonSettings>);

            const pointSeries = chart.series.push(
                am5map.MapPointSeries.new(root, {
                    geoJSON: cities[key]?.(12),
                }),
            );

            pointSeries.bullets.push(function () {
                let label = am5.Label.new(root, {
                    centerX: am5.p50,
                    centerY: am5.p50,
                    text: formatCurrency(regionData[key], 'en-US', '$', 'USD'),
                    fontSize: 36,
                    opacity: 0,
                    scale: 0.5,
                    fontWeight: '900',
                    stateAnimationEasing: am5.ease.bounce,
                    fontFamily: 'Sequel Sans, Helvetica, Arial, Sans-Serif',
                    fill: am5.color('#fff'),
                });

                label.animate({
                    key: 'opacity',
                    duration: 500,
                    easing: am5.ease.bounce,
                    to: 1,
                });
                label.animate({
                    key: 'scale',
                    duration: 500,
                    easing: am5.ease.bounce,
                    to: 1,
                });

                const bullet = am5.Bullet.new(root, {
                    sprite: label,
                });
                responsive.addRule({
                    relevant: function (width, height) {
                        return width < 768;
                    },
                    applying: function () {
                        label._settings.fontSize = 20;
                    },
                    removing: function () {
                        label._settings.fontSize = 36;
                    },
                });

                return bullet;
            });

            polygonSeries2.data.setAll([...data[key]]);
        },
    );
}
